const phonenumber = (function() {

  const self = {

    notNumbersPattern: /[^0-9]/g,

    parsePhoneNumber (phnum: string|number) {
      let valid: boolean = false, phstr: string = '', length: number
      let prefixOne = '', areaCode = '', exchange = '', subscriber = '', extension = ''

      // Phone number as string.
      if (typeof phnum === 'string') {
        phstr = phnum
      } else if (typeof phnum === 'number') {
        phstr = phnum.toString()
      }

      // Do not reformat international numbers. Up to user to format.
      if (phstr.charAt(0) === '+' || phstr.charAt(0) === '0') {
        return {
          valid: true,
          formatted: phstr,
          numbersOnly: phnum
        }  
      }

      // For North American numbers, continue with auto-formatting.
      phstr = phstr.replaceAll(self.notNumbersPattern, '')
      length = phstr.length
      phnum = parseInt(phstr)
      if (phstr.charAt(0) === '1') {
        prefixOne = '1 '
        phstr = phstr.substring(1, length)
      }
      length = phstr.length
      if (length>0) {
        areaCode = phstr.substring(0,3)
      }
      if (length>3) {
        exchange = phstr.substring(3,6)
      }
      if (length>6) {
        subscriber = phstr.substring(6,10)
      }
      if (length>10) {
        extension = phstr.substring(10, length)
      }
      if (extension) {
        valid = true
        phstr = `${prefixOne}(${areaCode}) ${exchange}-${subscriber} x${extension}`
      } else if (subscriber) {
        valid = subscriber.length===4
        phstr = `${prefixOne}(${areaCode}) ${exchange}-${subscriber}`
      } else if (exchange) {
        phstr = `${prefixOne}(${areaCode}) ${exchange}`
      } else if (areaCode) {
        phstr = `${prefixOne}(${areaCode}`
      } else if (prefixOne) {
        phstr = '1'
      }
      return {
        valid,
        formatted: phstr,
        numbersOnly: phnum,
        areaCode,
        exchange,
        subscriber,
        extension
      }
    }

  }

  return self
})();

export default phonenumber
